import { useMutation, useQueryClient } from '@tanstack/react-query'
import { profile } from '@myap/ui-library'
import { deleteRequest } from '../utils/fetchOperations'
import { SCORE_SEND_KEY } from '../components/_common/reactquery'

const useDeleteStudentScoreSendMutation = ({ educationPeriodCd, studentId }) => {
  const queryClient = useQueryClient()
  const { apiUrl } = profile()
  return useMutation({
    mutationKey: [SCORE_SEND_KEY, educationPeriodCd, studentId],
    mutationFn: async ({ signal }) => {
      return await deleteRequest({
        url: `${apiUrl}/score-send-di/education-period-cd/${educationPeriodCd}/studentId/${studentId}`,
        signal,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [SCORE_SEND_KEY] })
    },
  })
}

export default useDeleteStudentScoreSendMutation
